var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCodeMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14,32H6c-1.1025391,0-2,0.8974609-2,2v8c0,1.1025391,0.8974609,2,2,2h8c1.1025391,0,2-0.8974609,2-2v-8 C16,32.8974609,15.1025391,32,14,32z M14,42H6v-8h8V42z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 37,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 22,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,16h8c1.1025391,0,2-0.8974609,2-2V6c0-1.1025391-0.8974609-2-2-2H6C4.8974609,4,4,4.8974609,4,6v8 C4,15.1025391,4.8974609,16,6,16z M6,6h8v8H6V6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,4h-8c-1.1025391,0-2,0.8974609-2,2v8c0,1.1025391,0.8974609,2,2,2h8c1.1025391,0,2-0.8974609,2-2V6 C44,4.8974609,43.1025391,4,42,4z M42,14h-8V6h8V14z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 9,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,16h4v-2h-4V4h-2v10C18,15.1025391,18.8974609,16,20,16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,10h4c1.1025391,0,2-0.8974609,2-2V4h-2v4h-4V6h-2v2C22,9.1025391,22.8974609,10,24,10z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,22c1.1025391,0,2-0.8974609,2-2v-2h-2v2h-6v2H20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,20v6h2v-6c0-1.1025391-0.8974609-2-2-2h-2c-1.1025391,0-2,0.8974609-2,2v6h2v-6H28z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 26,
    width: 2,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 22,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 24,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,26v-2h-2v2h-4v2h4C19.1025391,28,20,27.1025391,20,26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,30h8v-2H6v-2H4v2C4,29.1025391,4.8974609,30,6,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,30h-2v2h2v2h2v-2C20,30.8974609,19.1025391,30,18,30z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 34,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,42v-4h-2v4c0,1.1025391,0.8974609,2,2,2h2c1.1025391,0,2-0.8974609,2-2v-4h-2v4H20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,16h2v-2c0-1.1025391-0.8974609-2-2-2h-4v2h4V16z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 26,
    width: 2,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 30,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,36h-2v-4h-2v4c0,1.1025391,0.8974609,2,2,2h2c1.1025391,0,2-0.8974609,2-2v-4h-2V36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,26h-2v2h2v4h2v-4C34,26.8974609,33.1025391,26,32,26z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 40,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,42h-4v2h4c1.1025391,0,2-0.8974609,2-2V32h-2V42z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 18,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,20h-6v2h6v2h-4v2h4c1.1025391,0,2-0.8974609,2-2v-2C44,20.8974609,43.1025391,20,42,20z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 26,
    width: 2,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 32,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 40,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,30h2v-2h-2c-1.1025391,0-2,0.8974609-2,2v2h2V30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,36v2h4c1.1025391,0,2-0.8974609,2-2v-4h-2v4H38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,42h-2v2h2c1.1025391,0,2-0.8974609,2-2v-2h-2V42z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18,
    width: 4,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 4,
    width: 2,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeMedium);
export default __webpack_public_path__ + "static/media/qr-code--medium.7cdb5282c86eef3b018f13f9b33dd31f.svg";
export { ForwardRef as ReactComponent };